export var Browser;
(function (Browser) {
    Browser["Chrome"] = "Chrome";
    Browser["Firefox"] = "Firefox";
    Browser["Edge"] = "Edge";
    Browser["Safari"] = "Safari";
    Browser["InternetExplorer"] = "Internet Explorer";
    Browser["Unknown"] = "Unknown";
})(Browser || (Browser = {}));
const versionRegExp = {
    chrome: /Chrome\/([0-9.]+)/,
    firefox: /Firefox\/([0-9.]+)/,
    edge: /Edge\/([0-9.]+)/,
    safari: /Version\/([0-9.]+)/,
    internetExplorer: /(MSIE|rv:)([0-9.]+)/
};
export function getBrowserInfo() {
    const userAgent = navigator.userAgent;
    let browserName = 'Unknown';
    let browserVersion = 'Unknown';
    if (userAgent.includes('Chrome')) {
        browserName = Browser.Chrome;
        browserVersion = userAgent.match(versionRegExp.chrome)?.[1] || 'Unknown';
    }
    else if (userAgent.includes('Firefox')) {
        browserName = Browser.Firefox;
        browserVersion = userAgent.match(versionRegExp.firefox)?.[1] || 'Unknown';
    }
    else if (userAgent.includes('Edge')) {
        browserName = Browser.Edge;
        browserVersion = userAgent.match(versionRegExp.edge)?.[1] || 'Unknown';
    }
    else if (userAgent.includes('Safari') && userAgent.includes('Version/')) {
        browserName = Browser.Safari;
        browserVersion = userAgent.match(versionRegExp.safari)?.[1] || 'Unknown';
    }
    else if (userAgent.includes('MSIE') || userAgent.includes('Trident/')) {
        browserName = Browser.InternetExplorer;
        browserVersion = userAgent.match(versionRegExp.internetExplorer)?.[2] || 'Unknown';
    }
    return {
        name: browserName,
        version: browserVersion
    };
}
export const browserInfo = getBrowserInfo();
